import PropTypes from 'prop-types'
import { Routes, Route } from 'react-router-dom'
import Calificar from './calificar/Calificar'
import Carrito from './carrito/Carrito'
import Categorias from './categorias/Categorias'
import ContenedorCategorias from './categorias/ContenedorCategorias'
import Subcategorias from './categorias/Subcategorias'
import CompraDirecta from './compraDirecta/CompraDirecta'
import Compras from './compras/Compras'
import Comprobante from './compras/Comprobante'
import PasarelaPago from './compras/PasarelaPago'
import Contacto from './contacto/Contacto'
import Favoritos from './favoritos/Favoritos'
import Lista from './lista/Lista'
import ListaVenta from './lista/ListaVenta'
import Login from './login/Login'
import DetallePreguntas from './pages/preguntas/DetallePreguntas'
import PreguntasPublicaciones from './pages/preguntas/PreguntasPublicaciones'
import PublicacionDetalle from './pages/PublicacionDetalle'
import Pedidos from './pedidos/Pedidos'
import AdministrarDomicilios from './perfil/AdministrarDomicilios'
import Password from './perfil/Password'
import Perfil from './perfil/Perfil'
import DetallePresupuesto from './presupuestos/DetallePresupuesto'
import Presupuestos from './presupuestos/Presupuestos'
import PublicacionDetalleAdmin from './publicaciones/administrar/Detalle'
import PublicacionesAdmin from './publicaciones/administrar/Publicaciones'
import Publicaciones from './publicaciones/Publicaciones'
import PublicacionGrabada from './publicar/PublicacionGrabada'
import Publicar from './publicar/Publicar'
import Registro from './registro/Registro'
import Verificar from './registro/Verificar'
import PedidoDetalle from './reutilizables/pedidos/PedidoDetalle'
import PedidoItemDetalle from './reutilizables/pedidos/PedidoItemDetalle'
import Scraps from './scraps/Scraps'
import ConvertirTiendaOficial from './tiendasoficiales/convertirTiendaOficial/ConvertirTiendaOficial'
import TiendasOficiales from './tiendasoficiales/TiendasOficiales'

const ContenedorPrincipal = (props) => {
  return (
    <Routes>
      <Route exact path="/" element={<Login />} />
      <Route path="/Pedidos" element={<Pedidos esVentas={false} />} />
      <Route path="/PedidoItem/:idPedidoItem" element={<PedidoItemDetalle />} />
      <Route path="/Pedido/:idPedido" element={<PedidoDetalle />} />
      <Route path="/PreguntasComprador" element={<PreguntasPublicaciones tipo={'comprador'} />} />
      <Route
        path="/PreguntasComprador/:idPublicacion/:idVendedor"
        element={<DetallePreguntas {...props} tipo={'comprador'} />}
      />
      <Route path="/PreguntasVendedor" element={<PreguntasPublicaciones tipo={'vendedor'} />} />
      <Route
        path="/PreguntasVendedor/:idPublicacion/:idVendedor"
        element={<DetallePreguntas {...props} tipo={'vendedor'} />}
      />
      <Route path="/Registro" element={<Registro />} />
      <Route path="/Verificar/:idUsuario/:codigoVerif" element={<Verificar />} />
      <Route path="/Favoritos" element={<Favoritos />} />
      <Route path="/Publicaciones/Administrar" element={<PublicacionesAdmin />} />
      {/* administración de Publicaciones */}
      <Route
        path="/Publicaciones/Administrar/:idPublicacion"
        element={<PublicacionDetalleAdmin />}
      />
      <Route path="/Publicaciones/TiendasOficiales/:idVendedor" element={<Publicaciones />} />
      <Route path="/Publicaciones/Subcategorias/:idSubCategoria" element={<Publicaciones />} />
      <Route path="/Publicaciones/Detalle/:idPublicacion" element={<Publicaciones />} />
      <Route path="/Publicaciones" element={<Publicaciones />} />
      <Route path="/Publicacion/:id" element={<PublicacionDetalle />} />
      <Route path="/Publicar" element={<Publicar />} />
      <Route path="/TiendasOficiales" element={<TiendasOficiales />} />
      <Route path="/ConvertirTiendaOficial" element={<ConvertirTiendaOficial />} />
      <Route path="/Presupuestos" element={<Presupuestos esVendedor={true} />} />
      <Route path="/PresupuestosComprador" element={<Presupuestos esVendedor={false} />} />
      <Route path="/Presupuesto/:idPresupuesto" element={<DetallePresupuesto />} />
      <Route path="/Perfil" element={<Perfil cambiarImagenPerfil={props.cambiarImagenPerfil} />} />
      <Route path="/AdministrarDomicilios" element={<AdministrarDomicilios />} />
      <Route path="/Password" element={<Password />} />
      <Route path="/Contacto" element={<Contacto />} />
      <Route
        path="/CalificarVendedor/:idPublicacion/:idVendedor/:idPedidoItem"
        element={<Calificar />}
      />
      <Route
        path="/CalificarProducto/:idPublicacion/:idVendedor/:idPedidoItem"
        element={<Calificar />}
      />
      <Route path="/Carrito" element={<Carrito />} />
      <Route path="/Compras" element={<Compras />} />
      <Route path="/Compras/:idPublicacion" element={<Compras />} />
      <Route path="/PasarelaPago" element={<PasarelaPago />} />
      <Route path="/Comprobante/:idPedido" element={<Comprobante />} />
      <Route path="/Ventas" element={<Pedidos esVentas={true} />} />
      <Route path="/Categorias" element={<ContenedorCategorias />} />
      <Route path="/Categorias/:categoria" element={<Categorias />} />
      <Route path="/Subcategorias/:idCategoria/:descripcion" element={<Subcategorias />} />
      <Route path="/Scraps" element={<Scraps />} />
      <Route path="/PublicacionGrabada" element={<PublicacionGrabada />} />
      <Route path="/PublicacionesOfertas" element={<Publicaciones ofertas="S" />} />
      <Route path="/compraDirecta" element={<CompraDirecta />} />
      <Route path="/Listas" element={<Lista />} />
      <Route path="/ListasVenta" element={<ListaVenta />} />
    </Routes>
  )
}

ContenedorPrincipal.propTypes = {
  cambiarImagenPerfil: PropTypes.func.isRequired
}

export default ContenedorPrincipal
